import { MAIN_ID, FIXED_HEADER_ID, useTailwindBreakpoint } from '../../..';
import { Toast, useLayoutStateContext, useUIContext } from '../../providers';

export const getToastAnimationClass = (toast?: Toast): string | undefined => {
    if (toast?.options?.animation) {
        if (toast?.isLeaving) {
            return 'animate-toast-slide-out-mobile tablet:animate-toast-slide-out-desktop';
        }
        return 'animate-toast-slide-in-mobile tablet:animate-toast-slide-in-desktop';
    }
};

export const useToastContainer = (isMobile: boolean) => {
    const {
        menuModal: { isOpen, modalIdInView },
    } = useUIContext();
    if (typeof window === 'undefined') {
        return null;
    }

    if (isOpen) {
        return document.getElementById(modalIdInView);
    }

    if (isMobile) {
        return document.getElementById(MAIN_ID);
    }

    return document.getElementById(FIXED_HEADER_ID);
};

export const useToastContainerStyle = (isMobile: boolean, toastOptions?: Toast['options']) => {
    const {
        header: { headerHeight },
    } = useLayoutStateContext();
    const {
        menuModal: { isOpen: isModalOpen },
    } = useUIContext();

    const {
        fixedAddToBasket: { fixedAddToBasketVisible, fixedAddToBasketHeight },
    } = useLayoutStateContext();

    if (isModalOpen) {
        if (isMobile) {
            if (toastOptions?.hasModalFooter) {
                return {
                    classNames: 'bottom-[5rem]',
                };
            }
            return {
                classNames: 'bottom-0',
            };
        }

        return {
            classNames: '!w-full top-headerFixedNavDesktop tablet:max-w-full desktop:max-w-full',
        };
    }

    if (isMobile) {
        if (fixedAddToBasketVisible) {
            return {
                bottom: `${fixedAddToBasketHeight}px`,
            };
        }

        return {
            clasNammes: `bottom-0`,
        };
    }

    return {
        top: headerHeight,
    };
};

export const useToastContainerPositioning = (toast?: Toast) => {
    const isMobile = useTailwindBreakpoint('tablet', false, true);

    const { classNames, ...style } = useToastContainerStyle(isMobile, toast?.options);
    const container = useToastContainer(isMobile);

    return {
        style,
        container,
        zIndex: isMobile ? 'z-toastMobile' : 'z-toast',
        classNames,
        animationClass: getToastAnimationClass(toast),
    };
};
